import { InputPassword } from "components";
import React, { useState } from 'react';
import { Snackbar, Typography, List, ListItem } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import LockIcon from '@mui/icons-material/Lock';
import { changePassword } from 'services';
import { Breadcrumb } from 'components';

export const ChangePassword = () => {
    const [currentPassword, setCurrentPassword] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [valid, setValid] = useState(false);
    const [matchError, setMatchError] = useState(false);
    const [formatError, setFormatError] = useState(false);
    const [isValidError, setIsValidError] = useState(false);
    const [isValidErrorMessage, setIsValidErrorMessage] = useState('');
    const [incorrectError, setIncorrectError] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[#?!@$%^&*-_])[A-Za-z\d#?!@$%^&*-_]{15,}$/g;
    const validateForm = () => {
        if (password && password.match(passwordPattern) == null) {
            setFormatError(true);
            return 1
        }
        if (password !== confirmPassword) {
            setMatchError(true);
            return 2
        }
        return 3
    }

    const confirm = (e: any) => {
        e.preventDefault();
        let validate = validateForm();
        if (validate !== 3) {
            return
        }
        setLoading(true);

        const params = {
            "oldPassword": currentPassword,
            "newPassword": confirmPassword
        }
        changePassword(params).then((res: any) => {
            if (res && res.status && res.status === 200) {
                setValid(true);
            } else if (res.status === 422) {
                setIsValidError(true);
                setIsValidErrorMessage(res.data);
            } else if (res.status === 500) {
                setError(true);
            } else if (res.status === 400) {
                setIncorrectError(true);
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
        props,
        ref,
    ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    let nav: any = [{ name: 'Home', path: '/home' }, { name: 'Change Password', path: '/home/changePassword' }];

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }}>
                <Breadcrumb navList={nav} />
            </div>
            <form onSubmit={confirm} style={{ width: '100%', maxWidth: '480px', margin: 'auto', textAlign: 'center', paddingTop: '100px', paddingBottom: '100px' }}>
                <Typography variant="h6" data-testid="reset-title">Change Password</Typography>
                <InputPassword
                    inputProps={{
                        "data-testid": 'password-field',
                    }}
                    pattern={passwordPattern}
                    required
                    onChange={(ev: any) => setCurrentPassword(ev.target.value)}
                    label="Current Password"
                    id="currentPassword-id"
                />
                <InputPassword
                    inputProps={{
                        "data-testid": 'password-field',
                    }}
                    pattern={passwordPattern}
                    required
                    onChange={(ev: any) => setPassword(ev.target.value)}
                    label="Password"
                    id="password-id"
                />
                <InputPassword
                    inputProps={{
                        "data-testid": 'confirmPassword-field',
                    }}
                    required onChange={(ev: any) => setConfirmPassword(ev.target.value)}
                    label="Confirm Password"
                    id="confirmPassword-id"
                />
                <List sx={{ listStyleType: 'disc', fontSize: '12px', marginLeft: '20px' }}>
                    <ListItem sx={{ display: 'list-item' }}>Password must have at least 15 characters</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Password must have at least one lowercase character (a-z)</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Password must have at least one uppercase character (A-Z)</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Password must have at least one digit (0-9)</ListItem>
                    <ListItem sx={{ display: 'list-item' }}>Password must have at least one special character ('#?!@$%^&*-_')</ListItem>
                </List>
                <LoadingButton role="confirm-button" loading={loading} type="submit" sx={{ m: 1 }} variant="contained" startIcon={<LockIcon />}>
                    Change Password
                </LoadingButton>
                <Snackbar open={valid} autoHideDuration={3000} onClose={() => setValid(false)}>
                    <Alert severity="success" onClose={() => setValid(false)}>
                        Password has changed successfully
                    </Alert>
                </Snackbar>
                <Snackbar open={matchError} autoHideDuration={3000} onClose={() => setMatchError(false)}>
                    <Alert severity="error" data-testid="mismatch-error" onClose={() => setMatchError(false)}>
                        Passwords do not match
                    </Alert>
                </Snackbar>
                <Snackbar open={formatError} autoHideDuration={3000} onClose={() => setFormatError(false)}>
                    <Alert severity="error" onClose={() => setFormatError(false)}>
                        Password doesnot meet criteria
                    </Alert>
                </Snackbar>
                <Snackbar open={isValidError} autoHideDuration={3000} onClose={() => setIsValidError(false)}>
                    <Alert severity="error" onClose={() => setIsValidError(false)}>
                        {isValidErrorMessage}
                    </Alert>
                </Snackbar>
                <Snackbar open={error} autoHideDuration={3000} onClose={() => setError(false)}>
                    <Alert severity="warning" onClose={() => setError(false)}>
                        Something went wrong please try again
                    </Alert>
                </Snackbar>
                <Snackbar open={incorrectError} autoHideDuration={3000} onClose={() => setIncorrectError(false)}>
                    <Alert severity="warning" onClose={() => setIncorrectError(false)}>
                        Old Password is incorrect!
                    </Alert>
                </Snackbar>
            </form>
        </div>
    )
}

export default ChangePassword;
